(function () {
    'use strict';

    angular.module("imApp").factory("freightRateSetsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1553,
                    parameters: parms || {}
                });
            },
            listViews: function (parms) {
                return $ihttp.post({
                    method: 1541,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
